module.exports = "/fonts/vendor/@fortawesome/fontawesome-pro/webfa-duotone-900.woff2?df908346e1ecacb69c36af17b6765214";